import { render, staticRenderFns } from "./UserExperienceUpdate.vue?vue&type=template&id=067cbac3&"
import script from "./UserExperienceUpdate.vue?vue&type=script&lang=js&"
export * from "./UserExperienceUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports